import { ADDITIONAL_COURSE_ID } from "../Constants/courses"

export function isCourseBuilderWorkshop(pyp) {
  return Number(pyp?.navigation?.currentCourseId) === ADDITIONAL_COURSE_ID
}

export const buildWorkshopLocation = (moduleTitle, navigation, suffix = "") => {
  const { currentCourseId, currentCourseName } = navigation || {}
  const pathname = `/workshop/${moduleTitle}${suffix}`
  const useCourseId =
    currentCourseId != null &&
    Number(currentCourseId) === ADDITIONAL_COURSE_ID
  return {
    pathname,
    search: useCourseId ? `?courseId=${currentCourseId}` : "",
    state: useCourseId
      ? { courseId: currentCourseId, courseName: currentCourseName }
      : { courseName: currentCourseName || "Pursue Your Purpose" }
  }
}
